import { render } from "./ScoresContent.vue?vue&type=template&id=d9e1f3e2&scoped=true&ts=true"
import script from "./ScoresContent.vue?vue&type=script&lang=ts"
export * from "./ScoresContent.vue?vue&type=script&lang=ts"

import "./ScoresContent.vue?vue&type=style&index=0&id=d9e1f3e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e1f3e2"]])

export default __exports__